
const digest = '30d017c517f4e17bcfb1275b6154c8218a773a46e12cc9243e6d3af30705abc1';
const classes = {"wrapper":"_wrapper_14irw_1","basicData":"_basicData_14irw_9","col":"_col_14irw_17","profileImage":"_profileImage_14irw_21","title":"_title_14irw_29","dateOfDeath":"_dateOfDeath_14irw_42","cross":"_cross_14irw_48","item":"_item_14irw_51","name":"_name_14irw_60","code":"_code_14irw_65","bold":"_bold_14irw_73","text":"_text_14irw_77","icon":"_icon_14irw_89","link":"_link_14irw_93","hiddenButton":"_hiddenButton_14irw_99","doctors":"_doctors_14irw_106","ml":"_ml_14irw_140","healthCard":"_healthCard_14irw_143","card":"_card_14irw_152","legalRepresentative":"_legalRepresentative_14irw_156","legalRepresentativeTitle":"_legalRepresentativeTitle_14irw_159","editButtonWrapper":"_editButtonWrapper_14irw_164"};
const css = `._wrapper_14irw_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
}
._wrapper_14irw_1 ._basicData_14irw_9 {
  display: flex;
  flex-direction: row;
  padding: 24px;
  border-bottom: 1px solid #eaedf3;
  gap: 16px;
  position: relative;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 {
  display: flex;
  flex-direction: column;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._profileImage_14irw_21 {
  height: 54px;
  width: 54px;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  object-fit: cover;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._title_14irw_29 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #000000;
  display: flex;
  gap: 20px;
  align-items: center;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._title_14irw_29 span {
  color: #97a4ba;
  font-size: 12px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._title_14irw_29 ._dateOfDeath_14irw_42 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._title_14irw_29 ._dateOfDeath_14irw_42 ._cross_14irw_48 {
  height: 15px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 {
  display: flex;
  flex-direction: row;
  align-items: center;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._cross_14irw_48 {
  height: 15px;
  margin-left: 10px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._name_14irw_60 {
  font-size: 14px;
  color: #9ea0a5;
  min-width: 260px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._code_14irw_65 {
  font-size: 14px;
  font-weight: 500;
  margin-right: 12px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._code_14irw_65 span {
  font-weight: 400;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._bold_14irw_73 {
  font-size: 14px;
  font-weight: 500;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._text_14irw_77 {
  font-size: 14px;
  color: #3e3f42;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._text_14irw_77 span {
  color: #9ea0a5;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._text_14irw_77 a {
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._icon_14irw_89 {
  margin-left: -23px;
  margin-right: 7px;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._col_14irw_17 ._item_14irw_51 ._link_14irw_93 {
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}
._wrapper_14irw_1 ._basicData_14irw_9 ._hiddenButton_14irw_99 {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0;
  right: 0;
}
._wrapper_14irw_1 ._doctors_14irw_106 {
  background-color: #fbfbfd;
  border-bottom: 1px solid #eaedf3;
  border-top: 0;
  padding: 33px 92px;
}
._wrapper_14irw_1 ._doctors_14irw_106 ._title_14irw_29 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #000000;
}
._wrapper_14irw_1 ._doctors_14irw_106 ._item_14irw_51 {
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-bottom: 15px;
}
._wrapper_14irw_1 ._doctors_14irw_106 ._item_14irw_51 ._name_14irw_60 {
  font-size: 14px;
  color: #9ea0a5;
  min-width: 250px;
}
._wrapper_14irw_1 ._doctors_14irw_106 ._item_14irw_51 ._text_14irw_77 {
  font-size: 14px;
  color: #3e3f42;
  min-width: 300px;
}
._wrapper_14irw_1 ._doctors_14irw_106 ._item_14irw_51 ._link_14irw_93 {
  color: #1665d8;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}
._wrapper_14irw_1 ._doctors_14irw_106 ._ml_14irw_140 {
  margin-left: 5px;
}
._wrapper_14irw_1 ._healthCard_14irw_143 {
  padding: 33px 92px;
}
._wrapper_14irw_1 ._healthCard_14irw_143 ._title_14irw_29 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #000000;
}
._wrapper_14irw_1 ._healthCard_14irw_143 ._card_14irw_152 {
  max-width: 200px;
}

._legalRepresentative_14irw_156 {
  margin-top: 20px;
}
._legalRepresentative_14irw_156 ._legalRepresentativeTitle_14irw_159 {
  font-weight: 500;
  font-size: 14px;
  min-width: 260px;
}
._legalRepresentative_14irw_156 ._editButtonWrapper_14irw_164 {
  display: flex;
  justify-content: flex-end;
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  